import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import BlogNavigation from '@/components/BlogNavigation';
import { CategoryShort } from '@/typings/model';
import { BreadCrumbType } from '@/typings/common';

import Top from './components/Top';

type Props = {
  categories: Array<CategoryShort>;
  pageTitle: string;
  breadCrumbList: BreadCrumbType[];
  className?: string;
};

const BlogSharedHeader = ({
  categories,
  pageTitle,
  breadCrumbList,
  className,
}: Props) => {
  const t = useTranslations();
  return (
    <Component>
      <Top pageTitle={pageTitle} breadCrumbList={breadCrumbList} />
      <BlogNavigation
        title={t('blog.all_sections')}
        categories={categories}
        className={className}
      />
    </Component>
  );
};

export default BlogSharedHeader;

const Component = styled.div``;
